// 制御文字の除去と、自動バインド（import だけで動く版）

const removeControlChars = (str) => {
    if (typeof str !== "string") return str;
    return str.replace(/\p{Cc}/gu, "");
};

const bindControlCharSanitizerToEl = (el) => {
    const handler = () => {
        const cleaned = removeControlChars(el.value);
        if (el.value !== cleaned) el.value = cleaned;
    };
    el.addEventListener("input", handler);
    el.addEventListener("change", handler); // オートフィル/IME確定のフォールバック
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('input[data-control-chars="sanitize"]')
        .forEach(bindControlCharSanitizerToEl);
});
